import React, { useEffect, useState } from "react";
import formatDate from "../../components/Control/formatDate";
import Styled from "styled-components";
import { mdiFileExcel } from "@mdi/js";
import Icon from "@mdi/react";
import Tooltip from "@material-ui/core/Tooltip";
import PrintIcon from "@material-ui/icons/Print";
import { Wrapper } from "../../components/Control/Flexbox";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useAuth } from "../../context/GlobalContext";
import { images, textInputs } from "../../constants/constants";
import TableToExcel from "@dayalk/table-to-excel";
import { CenteredLogoImg } from "../../golbalStyles/global.styled";

const Table = Styled.table`
	margin-bottom: 1rem;
    th{
        font-size: 12px;
		    font-family:"Roboto",sans-serif;
        border: 1px solid black;
        padding: 0.4rem;
        p{
          margin:0;
        }
    }
    td{
        font-size: 12px;
        border: 1px solid black;
        padding: 0.3rem;
        p{
          margin:0;
        }
    }
    span{
      font-weight:500;
    }

`;

const mergerRowsFmea = (fmeaData) => {
  const fmeaParams = [
    { param: "requirement" },
    { param: "potential_mode" },
    { param: "severity" },
    { param: "failure_class" },
    { param: "potential_cause" },
    { param: "control_prevention" },
    { param: "control_detection" },
    { param: "recommendation_action" },
    { param: "det" },
    { param: "rec_action" },
    { param: "eof" },
  ];

  for (let [processIndex, process] of fmeaData.processes.entries()) {
    let prevRowValue = {};
    fmeaParams.forEach((item) => (prevRowValue[item.param] = null));
    let idxOfParmas = {};

    for (let [fmeaIndex, fmea] of process.failures.entries()) {
      fmeaParams.forEach((item, index) => {
        if (Array.isArray(fmea[item.param])) {
          fmea[item.param] = fmea[item.param][0];
        }
        if (
          prevRowValue[item.param] === fmea[item.param] &&
          prevRowValue[item.param] !== null &&
          prevRowValue[item.param] !== undefined
        ) {
          fmeaData.processes[processIndex].failures[idxOfParmas[item.param]][
            `${item.param}_rowSpan`
          ] += 1;
          fmea[`${item.param}_include`] = false;
        } else {
          idxOfParmas[item.param] = fmeaIndex;
          fmea[`${item.param}_rowSpan`] = 1;
          fmea[`${item.param}_include`] = true;
          prevRowValue[item.param] = fmea[item.param] || "";
        }
      });
    }
  }
};

const ViewFmeaTable = () => {
  const [fmeaData, setFmeaData] = useState({});
  const { id } = useParams();
  const { state: states } = useAuth();
  function printTable() {
    var divToPrint = document.getElementById("table-to-xls");
    let newWin = window.open("");
    newWin.document.write(divToPrint.outerHTML);
    newWin.print();
    newWin.close();
  }

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/get/fmea/${id}`)
        .then((res) => {
          if (res.data) {
            let data = res.data;
            mergerRowsFmea(data);
            setFmeaData(data);
          }
        })
        .catch((err) => console.log(err));
    }
  }, []);

  // console.log(fmeaData);

  return (
    <>
      <div className="divflex">
        <Typography
          variant="inherit"
          style={{
            fontSize: "24px",
          }}
        >
          FAILURE MODE & EFFECT ANALYSIS
        </Typography>
        <Wrapper>
          <Tooltip arrow title="Export as spreadsheet">
            <Button
              style={{
                backgroundColor: "#161a1d",
                borderColor: "#161a1d",
                color: "white",
                width: "fit-content",
                borderRadius: "0",
                paddingTop: "9px",
                cursor: "pointer",
              }}
              onClick={() => {
                TableToExcel.convert(document.getElementById("table-to-xls"), {
                  name: "Failure Mode And Effect Analysis.xlsx",
                  sheet: {
                    name: "fmeaSheet",
                  },
                });
              }}
            >
              <Icon path={mdiFileExcel} size={1.3} />
            </Button>
          </Tooltip>
        </Wrapper>
      </div>
      <div
        style={{
          margin: "0.1rem 0.5rem",
          paddingBottom: "4rem",
        }}
      >
        <section style={{ overflow: "scroll" }}>
          <Table
            cellSpacing="0"
            style={{
              marginTop: "0.6rem",
              backgroundColor: "white",
              width: "100%",
            }}
            id="table-to-xls"
            data-default-wrap="true"
            data-cols-width="10, 15, 17, 19, 5, 7, 18, 5, 18, 18, 5, 5, 15, 15, 15, 4, 4, 4, 4"
          >
            <thead>
              <tr>
                <th
                  colSpan="14"
                  rowSpan="4"
                  align="center"
                  style={{
                    border: "1px solid black",
                    fontSize: "1.6rem",
                    borderRight: "0px",
                    textAlign: "center",
                  }}
                  data-a-v="middle"
                >
                  <CenteredLogoImg>
                    <img
                      src={images.CompanyLogo}
                      alt={textInputs.companyName}
                      height="46"
                      width="120"
                    />
                    <span>{textInputs.companyName}</span>
                  </CenteredLogoImg>
                </th>
                <th
                  align="left"
                  colSpan="2"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  DOCUMENT NO:
                </th>
                <th
                  align="left"
                  colSpan="3"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  FMEA __
                </th>
              </tr>
              <tr data-height="15">
                <th
                  align="left"
                  colSpan="2"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  ISSUE DATE:
                </th>
                <th
                  align="left"
                  colSpan="3"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  01/04/2019
                </th>
              </tr>
              <tr data-height="15">
                <th
                  align="left"
                  colSpan="2"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  REVISION NO:
                </th>
                <th
                  align="left"
                  colSpan="3"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  01
                </th>
              </tr>
              <tr data-height="15">
                <th
                  align="left"
                  colSpan="2"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  REVISION DATE:
                </th>
                <th
                  align="left"
                  colSpan="3"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  15/03/2022
                </th>
              </tr>
              <tr>
                <th
                  colSpan={19}
                  align="center"
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    backgroundColor: "#1d1d1d",
                    color: "white",
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                  data-font-sz="18"
                  data-a-h="center"
                  data-f-bold="true"
                  data-fill-color="#1d1d1d"
                  data-f-color="FFFFFF"
                >
                  POTENTIAL FAILURE MODE AND EFFECTS ANALYSIS (PROCESS FMEA)
                </th>
              </tr>

              <tr>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  Item No. :-
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  {fmeaData?.part_id?.part_number}
                </th>

                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  Process Responsibility -
                </th>
                <th
                  colSpan={3}
                  style={{
                    border: "1px solid black",
                  }}
                  data-f-sz="10"
                >
                  {fmeaData?.process_resp}
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  FMEA Date(Orig.) -{" "}
                </th>
                <th
                  colSpan={4}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  {fmeaData?.fmea_date_origin}
                </th>
              </tr>
              <tr data-height="25">
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  Item Description:
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  {fmeaData.part_id?.part_name}
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  Key Date -{" "}
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  {fmeaData.key_date}
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  FMEA Rev. No. & Date -{" "}
                </th>
                <th
                  colSpan={4}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  {fmeaData?.rev_and_date}
                </th>
              </tr>
              <tr data-height="25">
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  Model Year(s)/Vehicle (s) -
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  {fmeaData.model_year_vehicle}
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  Drawing Rev. No. -{" "}
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  {fmeaData?.drawing_rev_no}
                </th>
                <th
                  colSpan={3}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  CFT Team -{" "}
                </th>
                <th
                  colSpan={4}
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                >
                  {fmeaData?.part_id?.core_team}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ fontWeight: "500" }} data-height="65">
                <th
                  align="center"
                  rowSpan={2}
                  style={{ border: "1px solid black", textAlign: "center" }}
                  data-f-sz="10"
                >
                  Item / Function
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    // minWidth: "10rem",
                  }}
                  data-f-sz="10"
                >
                  Requirement
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    minWidth: "10rem",
                  }}
                  data-f-sz="10"
                >
                  Potential Failure Mode
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    minWidth: "12rem",
                  }}
                  data-f-sz="10"
                >
                  Potential Effect(s) of Failure
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  Sev.
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  Class
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    minWidth: "12rem",
                  }}
                  data-f-sz="10"
                >
                  Potential cause(s) of Failure
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  Occ.
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    minWidth: "12rem",
                  }}
                  data-f-sz="10"
                >
                  Current Process Controls (Prevention )
                </th>

                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    minWidth: "12rem",
                  }}
                  data-f-sz="10"
                >
                  Current Process Controls (Detection )
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  Det.
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  R.P.N.
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{ border: "1px solid black", textAlign: "center" }}
                  data-f-sz="10"
                >
                  Recommended Action(s)
                </th>
                <th
                  align="center"
                  rowSpan={2}
                  style={{ border: "1px solid black", textAlign: "center" }}
                  data-f-sz="10"
                >
                  Resp. & Target completion date
                </th>
                <th
                  align="center"
                  colSpan={5}
                  style={{ border: "1px solid black", textAlign: "center" }}
                  data-f-sz="10"
                >
                  Action Results
                </th>
              </tr>
              <tr>
                <th
                  align="center"
                  style={{
                    border: "1px solid black",
                    width: "100px",
                    textAlign: "center",
                  }}
                  data-f-sz="10"
                >
                  Actions Taken
                </th>
                <th
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  Sev.
                </th>
                <th
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  Occ.
                </th>
                <th
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  Det.
                </th>
                <th
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    transform: "rotate(-90deg)",
                  }}
                  data-f-sz="10"
                  data-a-text-rotation="90"
                >
                  R.P.N.
                </th>
              </tr>
              {fmeaData.processes?.map((process) =>
                process?.failures?.map((fail, failInd) => (
                  <tr data-height="65">
                    {failInd === 0 && (
                      <td
                        align="center"
                        style={{ border: "1px solid black" }}
                        rowSpan={process.failures.length}
                        data-f-sz="10"
                      >
                        {process?.process_name}
                      </td>
                    )}
                    {fail.requirement_include && (
                      <td
                        align="center"
                        style={{ border: "1px solid black" }}
                        data-f-sz="10"
                        rowSpan={fail.requirement_rowSpan}
                      >
                        {fail?.requirement}
                      </td>
                    )}
                    {fail.potential_mode_include && (
                      <td
                        align="center"
                        style={{ border: "1px solid black" }}
                        data-f-sz="10"
                        rowSpan={fail.potential_mode_rowSpan}
                      >
                        {fail?.potential_mode}
                      </td>
                    )}
                    {fail.eof_include && (
                      <td
                        align="center"
                        style={{ border: "1px solid black" }}
                        data-f-sz="10"
                        rowSpan={fail.eof_rowSpan}
                      >
                        {Array.isArray(fail?.eof) ? fail.eof[0] : fail.eof}
                      </td>
                    )}

                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {fail?.severity}
                    </td>

                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                      height={fail?.failure_class ? "auto" : "30px"}
                    >
                      {fail?.failure_class}
                    </td>
                    {fail.potential_cause_include && (
                      <td
                        align="center"
                        style={{ border: "1px solid black" }}
                        data-f-sz="10"
                        rowSpan={fail?.potential_cause_rowSpan}
                      >
                        {Array.isArray(fail?.potential_cause)
                          ? fail.potential_cause[0]
                          : fail.potential_cause}
                      </td>
                    )}
                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {fail?.occ}
                    </td>
                    {fail.control_prevention_include && (
                      <td
                        align="center"
                        style={{ border: "1px solid black" }}
                        data-f-sz="10"
                        rowSpan={fail?.control_prevention_rowSpan}
                      >
                        {fail?.control_prevention}
                      </td>
                    )}

                    {fail.control_detection_include && (
                      <td
                        align="center"
                        style={{ border: "1px solid black" }}
                        data-f-sz="10"
                        rowSpan={fail.control_detection_rowSpan}
                      >
                        {fail?.control_detection}
                      </td>
                    )}

                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {fail?.det}
                    </td>

                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {(+fail.severity || 0) *
                        (+fail.occ || 0) *
                        (+fail.det || 0)}{" "}
                    </td>

                    {/* verify with rahul */}
                    {fail.rec_action_include && (
                      <td
                        align="center"
                        style={{ border: "1px solid black" }}
                        data-f-sz="10"
                        rowSpan={fail.rec_action_rowSpan}
                      >
                        {fail?.rec_action}
                      </td>
                    )}
                    <td align="center" data-f-sz="10">
                      {fail?.resp_target}
                    </td>
                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {fail?.action_taken}
                    </td>
                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {fail?.last_sev}
                    </td>
                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {fail?.last_occ}
                    </td>
                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {fail?.last_det}
                    </td>
                    <td
                      align="center"
                      style={{ border: "1px solid black" }}
                      data-f-sz="10"
                    >
                      {(+fail.last_sev || 0) *
                        (+fail.last_occ || 0) *
                        (+fail.last_det || 0)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tbody>
              <tr style={{ fontWeight: "bold" }}>
                <td
                  colSpan="2"
                  style={{ border: "1px solid black" }}
                  align="center"
                  rowSpan="2"
                  data-f-sz="11"
                >
                  Rev No.
                </td>
                <td
                  colSpan="3"
                  style={{ border: "1px solid black" }}
                  align="center"
                  rowSpan="2"
                  data-f-sz="11"
                >
                  Revision Date
                </td>
                <td
                  colSpan="9"
                  style={{ border: "1px solid black" }}
                  align="center"
                  rowSpan="2"
                  data-f-sz="11"
                >
                  Reason For Revision
                </td>
                <td
                  colSpan="5"
                  style={{ border: "1px solid black" }}
                  align="center"
                  rowSpan="2"
                  data-f-sz="11"
                >
                  Revision Reason
                </td>
              </tr>
              <tr style={{ height: "60px" }}></tr>
              {fmeaData?.revisionData &&
                fmeaData?.revisionData?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr data-height="150">
                        <td
                          colSpan="2"
                          style={{ border: "1px solid black" }}
                          align="center"
                          data-f-sz="11"
                        >
                          {item.rev_no}
                        </td>
                        <td
                          colSpan="3"
                          style={{ border: "1px solid black" }}
                          align="center"
                          data-f-sz="11"
                        >
                          {formatDate(item.rev_date)}
                        </td>
                        <td
                          colSpan="9"
                          style={{ border: "1px solid black" }}
                          align="center"
                          data-f-sz="11"
                        >
                          {item.summary}
                        </td>
                        <td
                          colSpan="5"
                          style={{ border: "1px solid black" }}
                          align="center"
                          data-f-sz="11"
                        >
                          {item.reason}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
            </tbody>
            <tbody>
              <tr style={{ height: "60px" }} data-height="30">
                <td
                  colSpan="4"
                  align="left"
                  style={{
                    border: "1px solid black",
                    fontWeight: "bold",
                  }}
                  data-f-sz="10"
                >
                  Prepared By:
                </td>
                <td
                  colSpan="5"
                  align="left"
                  style={{
                    border: "1px solid black",
                    textTransform: "capitalize",
                  }}
                  data-f-sz="10"
                >
                  {states.user.name}
                </td>

                <td
                  colSpan="4"
                  align="left"
                  style={{
                    border: "1px solid black",
                    fontWeight: "bold",
                  }}
                  data-f-sz="10"
                >
                  Approved By:
                </td>
                <td
                  colSpan="6"
                  align="left"
                  style={{ border: "1px solid black" }}
                  data-f-sz="10"
                ></td>
              </tr>
            </tbody>
          </Table>
        </section>
      </div>
    </>
  );
};

export default ViewFmeaTable;
